export const APPLY_FILTERS = 'APPLY_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_APPEND = 'SET_APPEND';
export const SET_LOADING = 'SET_LOADING';
export const FILTER_ITEMS = 'FILTER_ITEMS';
export const SET_TARGETING_ITEM = 'SET_TARGETING_ITEM';
export const SET_SUMMARY = 'SET_SUMMARY';
export const RESET = 'RESET';
export const SET_ASSET_DETAIL = 'SET_ASSET_DETAIL';
